export default __webpack_public_path__ + "static/media/back-arrow-grey.1c52e454.svg";